import { ICheckValidDateRoute, IGetValidRouteById } from 'interfaces/SaleLine';

export const SaleLine_VARIABLE = {
  getValidRouteById: ({
    routeId,
    statusId = 'R100_01',
  }: IGetValidRouteById) => {
    return {
      input: {
        id: { equals: routeId },
        statusId: { equals: statusId },
      },
    };
  },

  checkValidDateRoute: ({ routeId, validToDate }: ICheckValidDateRoute) => {
    return {
      input: {
        id: { equals: routeId },
        validToDate: { gte: validToDate },
      },
    };
  },
};
